module.exports = __webpack_public_path__ + "img/l-play.e10eb6c1.png";